// Column templates for the team's users table. A row always renders seven cells (checkbox, user,
// team and manager, license, Skill Dive, date, actions), with an empty Skill Dive cell when the
// column is hidden, so that track is 0 wide then. The header splits the row's team cell into its
// Team and Manager columns.
export const teamUsersTableGrid = (skillDiveColumn: boolean): { header: string; row: string } => {
  const userWidth = skillDiveColumn ? '25%' : '35%';
  return {
    header: `40px ${userWidth} 20% 10% 10% ${skillDiveColumn ? '10% ' : ''}10% 10%`,
    row: `40px ${userWidth} 30% 10% ${skillDiveColumn ? '10%' : '0'} 10% 10%`,
  };
};
